import { Table } from '@radix-ui/themes'

type Props = {
	label?: string
	data?: Array<any>
	mapping: Record<string, any>
	isHighlighted?: (entry: any) => boolean
	onRowClick?: (entry: any) => any
	columnToHighlight?: string
}
export default function SimpleTable({
	data,
	mapping,
	isHighlighted,
	label,
	onRowClick,
	columnToHighlight,
}: Props) {
	if (!data || data.length === 0) {
		return <div />
	}

	const columnNames = Object.keys(mapping).map(value => value)
	const includedKeys = Object.values(mapping)
	return (
		<div className="w-full">
			<label>{label || ''}</label>
			<Table.Root variant="surface">
				<Table.Header>
					<Table.Row>
						{columnNames.map(value => (
							<Table.ColumnHeaderCell key={value}>{value}</Table.ColumnHeaderCell>
						))}
					</Table.Row>
				</Table.Header>
				<Table.Body>
					{data.map((entry, i0) => {
						const highlighted = isHighlighted?.(entry)
						const styled = highlighted ? 'font-semibold text-black bg-yellow-500' : ''
						const cellValues = Object.fromEntries(
							Object.entries(entry).filter(([key, _]) => includedKeys.includes(key)),
						)
						return (
							<Table.Row className={styled} key={i0}>
								{Object.values(cellValues).map((value, i1) => {
									const column = Object.keys(cellValues)[i1]
									const highlightedCell = columnToHighlight === column
									return (
										<Table.Cell
											key={`${i0 + String(value) + String(i1)}`}
											className={`${highlighted ? 'text-black' : ''} ${highlightedCell ? 'cursor-pointer' : ''} capitalize`}
											onClick={() => {
												if (highlightedCell) onRowClick?.(entry)
											}}
										>
											{highlightedCell ? (
												highlighted ? (
													<span>{value as string}</span>
												) : (
													<span className="text-[#FF8DCC]">{value as string}</span>
												)
											) : (
												<span>{value as string}</span>
											)}
										</Table.Cell>
									)
								})}
							</Table.Row>
						)
					})}
				</Table.Body>
			</Table.Root>
		</div>
	)
}
